import { isProduction } from 'src/ui/constants/environment';
import { InstanceFlavors } from 'src/ui/features/connection';

const getTestId = (id: string, idx?: number) =>
  isProduction() && id ? `${idx}` : id;

export const CLOUD_PURCHASE_BUTTON = 'cloud-purchase-button';
export const CLOUD_TERMS_OF_SERVICE = 'sd-cloud-terms-service';
export const CONTENT_LOADING_SPINNER = 'content-loading-spinner';
export const CONNECTION_LIST_GET_CLOUD = 'connection-list-get-cloud';

export const DASHBOARD_BROWSER_AUTH_FAILED_WARNING =
  'dashboard-browser-auth-failed-warning';
export const DASHBOARD_CARDS = 'dashboard-cards';
export const DASHBOARD_COMMUNITY = 'dashboard-community';
export const DASHBOARD_DEGRADED_WARNING = 'dashboard-degraded-warning';
export const DASHBOARD_DOCS = 'dashboard-docs';
export const DASHBOARD_KNOWLEDGE_KITS = 'dashboard-knowledge-kits';
export const DASHBOARD_MANAGE_ENDPOINT_USERS =
  'dashboard-manage-endpoint-users';
export const DASHBOARD_MANAGE_ENDPOINTS = 'dashboard-manage-endpoints';
export const DASHBOARD_MANAGE_DATABRICKS = 'dashboard-manage-databricks';
export const DASHBOARD_TRAININGS = 'dashboard-trainings';
export const DASHBOARD_SSO_WARNING = 'dashboard-sso-warning';
export const DASHBOARD_UNAUTHORIZED_WARNING = 'dashboard-unauthorized-warning';

export const DIALOG_CLOSE_ICON_TEST_ID = 'dialog-close-icon';

export const DIAGNOSTIC_VOICEBOX_DATABASE_SELECTOR =
  'diagnostic-voicebox-database-selector';
export const DIAGNOSTIC_VOICEBOX_DATABASE_SELECTOR_ITEM = (
  id: string,
  idx?: number
) => `diagnostic-voicebox-database-selector-item-${getTestId(id, idx)}`;
export const DIAGNOSTIC_VOICEBOX_MODEL_SELECTOR =
  'diagnostic-voicebox-model-selector';
export const DIAGNOSTIC_VOICEBOX_MODEL_SELECTOR_ITEM = (
  id: string,
  idx?: number
) => `diagnostic-voicebox-model-selector-item-${getTestId(id, idx)}`;
export const DIAGNOSTIC_VOICEBOX_GENERATE_REPORT_BUTTON =
  'diagnostic-voicebox-generate-report-button';
export const DIAGNOSTIC_VOICEBOX_RESULTS_SPINNER =
  'diagnostic-voicebox-results-spinner';
export const VOICEBOX_RESPONSE_REPORT_DIALOG =
  'voicebox-response-report-dialog';
export const VOICEBOX_RESPONSE_REPORT_START_DATE_INPUT =
  'voicebox-response-report-start-date-input';
export const VOICEBOX_RESPONSE_REPORT_END_DATE_INPUT =
  'voicebox-response-report-end-date-input';
export const VOICEBOX_RESPONSE_REPORT_CANCEL_BUTTON =
  'voicebox-response-report-cancel-button';
export const VOICEBOX_RESPONSE_REPORT_SUBMIT_BUTTON =
  'voicebox-response-report-submit-button';
export const VOICEBOX_RESPONSE_REPORT_ERROR = 'voicebox-response-report-error';

export const LANDING_PAGE_ADD_CONNECTION = 'landing-page-add-connection';
export const LANDING_PAGE_GET_STARTED = 'landing-page-get-started';
export const LANDING_PAGE_BLOCKED_EMAIL_CONFIRMATION =
  'landing-page-blocked-email-confirmation';

export const PRODUCT_DESC_TEST_ID = 'product-description';
export const PRODUCT_CARD_TEST_ID = 'product-card';
export const DATABRICKS_CONNECTION_NAME = 'databricks_conn_name';
export const DATABRICKS_CONNECTION_SELECTOR = 'databricks_conn_selector';
export const FOOTER_LINKS_CONTAINER = 'footer-links-container';

export const CREATE_PROFILE_DIALOG_INDUSTRY_SELECTOR =
  'create-dialog-industry-selector';
export const CREATE_PROFILE_BEST_DESCRIBES_COMPANY_SELECTOR =
  'create-dialog-best-describes-company-selector';
export const CREATE_PROFILE_DIALOG_BEST_DESCRIBES_ROLE_SELECTOR =
  'create-dialog-best-describes-role-selector';
export const CREATE_PROFILE_TERMS_OF_USE_CHECKBOX =
  'create-dialog-terms-of-use-checkbox';
export const CREATE_PROFILE_PRIVACY_CHECKBOX = 'create-dialog-privacy-checkbox';

export const GET_STARTED_CTA = (flavor: InstanceFlavors) =>
  `get-started-cta-${flavor}`;
export const GET_STARTED_HEADER = 'get-started-header';
export const GET_STARTED_OVERVIEW = 'get-started-overview';

export const BUTTON_MP = 'button-mp';

export const MP_MENU_SEARCH = 'MP_MENU_SEARCH';
export const MP_MENU_SEARCH_BTN = 'MP_MENU_SEARCH_BTN';

export const KIT_CONNECTION_SELECTOR = 'kit-connection-selector';
export const KIT_CONNECTION_SELECTOR_OPTION = 'kit-connection-selector-option';
export const KIT_DB_SELECTOR_BUTTON = 'kit-db-selector-button';
export const KIT_DB_SELECTOR_MENU_ITEM = 'kit-db-selector-menu-item';
export const KIT_DB_SELECTOR_CREATE_NEW_MENU_ITEM =
  'kit-db-selector-create-menu-item';
export const KIT_DB_SELECTOR_CREATE_NEW_INVALID_MENU_ITEM =
  'kit-db-selector-create-invalid-menu-item';
export const KIT_ACTION_BUTTON = 'kit-action-button';
export const KIT_EXPLORER_BUTTON = 'kit-explorer-button';
export const KIT_OVERVIEW_PANEL = (id: string) => `overview-panel-${id}`;
export const KIT_VOICEBOX_ICON = 'kit-voicebox-icon';

export const MANAGE_API_TOKENS_CONTAINER = 'manage-api-tokens-container';
export const MANAGE_API_TOKENS_APP_CREATE = 'manage-api-tokens-app-create';
export const MANAGE_API_TOKENS_APP_TABLE = (id: string, idx?: number) =>
  `manage-api-tokens-app-table-${getTestId(id, idx)}`;
export const MANAGE_API_TOKENS_USER_CREATE = 'manage-api-tokens-user-create';
export const MANAGE_API_TOKENS_USER_TABLE = 'manage-api-tokens-user-table';

export const MANAGE_API_TOKEN_CREATE_DIALOG = 'manage-api-token-create-dialog';
export const MANAGE_API_TOKEN_CREATE_NAME_INPUT =
  'manage-api-token-create-name-input';
export const MANAGE_API_TOKEN_CREATE_EXPIRES_INPUT =
  'manage-api-token-create-expires-input';
export const MANAGE_API_TOKEN_CREATE_SECRET = 'manage-api-token-create-secret';

export const MANAGE_API_TOKEN_MENU = 'manage-api-token-menu';
export const MANAGE_API_TOKEN_DELETE = 'manage-api-token-delete';
export const MANAGE_API_TOKEN_DELETE_CANCEL = 'manage-api-token-delete-cancel';
export const MANAGE_API_TOKEN_DELETE_SUBMIT = 'manage-api-token-delete-submit';
export const MANAGE_API_TOKEN_ROW = (id: string, idx?: number) =>
  `manage-api-token-row-${getTestId(id, idx)}`;

export const MANAGE_VOICEBOX_APP_CREATE = 'manage-voicebox-app-create';
export const MANAGE_VOICEBOX_APP_MENU = 'manage-voicebox-app-menu';
export const MANAGE_VOICEBOX_APP_MENU_DELETE =
  'manage-voicebox-app-menu-delete';
export const MANAGE_VOICEBOX_APP_MENU_UPDATE =
  'manage-voicebox-app-menu-update';

export const MANAGE_VOICEBOX_APP_DELETE_CANCEL =
  'manage-voicebox-app-delete-cancel';
export const MANAGE_VOICEBOX_APP_DELETE_SUBMIT =
  'manage-voicebox-app-delete-submit';

export const MANAGE_VOICEBOX_APP_CREATE_DIALOG =
  'manage-voicebox-app-create-dialog';
export const MANAGE_VOICEBOX_APP_CREATE_CONNECTIONS =
  'manage-voicebox-app-create-connections';
export const MANAGE_VOICEBOX_APP_CREATE_CONNECTIONS_EMPTY =
  'manage-voicebox-app-create-connections-empty';
export const MANAGE_VOICEBOX_APP_CREATE_CONNECTION = (
  id: string,
  idx?: number
) => `manage-voicebox-app-create-connection-${getTestId(id, idx)}`;
export const MANAGE_VOICEBOX_APP_CREATE_DATABASE_ITEM = (
  id: string,
  idx?: number
) => `manage-voicebox-app-create-database-item-${getTestId(id, idx)}`;
export const MANAGE_VOICEBOX_APP_CREATE_DATABASE_SELECTOR =
  'manage-voicebox-app-create-database-selector';
export const MANAGE_VOICEBOX_APP_CREATE_GRAPH_ITEM = (
  id: string,
  idx?: number
) => `manage-voicebox-app-create-graph-item-${getTestId(id, idx)}`;
export const MANAGE_VOICEBOX_APP_CREATE_GRAPH_SELECTOR =
  'manage-voicebox-app-create-graph-selector';
export const MANAGE_VOICEBOX_APP_CREATE_MODEL_ITEM = (
  id: string,
  idx?: number
) => `manage-voicebox-app-create-model-item-${getTestId(id, idx)}`;
export const MANAGE_VOICEBOX_APP_CREATE_MODEL_SELECTOR =
  'manage-voicebox-app-create-model-selector';
export const MANAGE_VOICEBOX_APP_CREATE_NAME_INPUT =
  'manage-voicebox-app-create-name-input';
export const MANAGE_VOICEBOX_APP_CREATE_REASONING_SWITCH =
  'manage-voicebox-app-create-reasoning-switch';

export const MANAGE_VOICEBOX_APP_UPDATE_DIALOG =
  'manage-voicebox-app-update-dialog';
export const MANAGE_VOICEBOX_APP_UPDATE_NAME_INPUT =
  'manage-voicebox-app-update-name-input';

export const NAVBAR_AVATAR_MENU = 'navbar-avatar-menu';
export const NAVBAR_AVATAR_MENU_ITEM = (id: string) =>
  `navbar-avatar-menu-item-${id}`;

export const NAVBAR_EXPAND_BUTTON = 'navbar-expand-button';

export const NAVBAR_DROPDOWN_KNOWLEDGE_CATALOG_ITEM =
  'navbar-dropdown-knowledge-catalog-item';
export const NAVBAR_DROPDOWN_PORTAL_ITEM = 'navbar-dropdown-portal-item';
export const NAVBAR_DROPDOWN_VOICEBOX_ITEM = 'navbar-dropdown-voicebox-item';

export const NAVBAR_LEARN_STARDOG_MENU = 'navbar-learn-stardog-menu';
export const NAVBAR_LEARN_STARDOG_MENU_ITEM = (id: string) =>
  `navbar-learn-stardog-menu-item-${id}`;

export const NAVBAR_ORG_DASHBOARD_BUTTON =
  'navbar-organization-dashboard-button';

export const NAVBAR_PORTAL_ENDPOINT_BUTTON = 'navbar-portal-endpoint-button';

export const NAVBAR_SDU_DASHBOARD_BUTTON = 'navbar-sdu-dashboard-button';

export const LAUNCHPAD_SDU_DASHBOARD_HEADING =
  'launchpad-sdu-dashboard-heading';
export const LAUNCHPAD_SDU_DASHBOARD_BREADCRUMB_UNITS =
  'launchpad-sdu-dashboard-breadcrumb-units';

export const SDU_DASHBOARD_TILE_TOTAL = 'sdu-dashboard-tile-total';
export const SDU_DASHBOARD_TILE_ENDPOINT_COUNT =
  'sdu-dashboard-tile-endpoint-count';
export const SDU_DASHBOARD_DATE_RANGE = 'sdu-dashboard-date-range';
export const SDU_DASHBOARD_CHART = 'sdu-dashboard-chart';
export const SDU_DASHBOARD_CHART_PLACEHOLDER =
  'sdu-dashboard-chart-placeholder';
export const SDU_DASHBOARD_CHART_GROUP_BY = (grain: string, idx?: number) =>
  `sdu-dashboard-chart-group-by-${getTestId(grain, idx)}`;
export const SDU_DASHBOARD_BREAKDOWN = 'sdu-dashboard-breakdown';
export const SDU_DASHBOARD_BREAKDOWN_PLACEHOLDER =
  'sdu-dashboard-breakdown-placeholder';
export const SDU_DASHBOARD_BREAKDOWN_LEGEND_LABEL = (
  group: string,
  idx?: number
) => `sdu-dashboard-breakdown-legend-label-${getTestId(group, idx)}`;
export const SDU_DASHBOARD_BREAKDOWN_LEGEND_VALUE = (
  group: string,
  idx?: number
) => `sdu-dashboard-breakdown-legend-value-${getTestId(group, idx)}`;
export const SDU_DASHBOARD_ENDPOINT_TABLE_SEARCH =
  'sdu-dashboard-endpoint-table-search';
export const SDU_DASHBOARD_ENDPOINT_TABLE_ROW = (id: string, idx?: number) =>
  `sdu-dashboard-endpoint-table-row-${getTestId(id, idx)}`;
export const SDU_DASHBOARD_ENDPOINT_TABLE_ROW_UNITS = (
  id: string,
  idx?: number
) => `sdu-dashboard-endpoint-table-row-units-${getTestId(id, idx)}`;
export const SDU_DASHBOARD_ENDPOINT_TABLE_COLUMN_SORT = (
  key: string,
  idx?: number
) => `sdu-dashboard-endpoint-table-column-sort-${getTestId(key, idx)}`;
export const SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU =
  'sdu-dashboard-endpoint-actions-menu';
export const SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU_ITEM = (id: string) =>
  `sdu-dashboard-endpoint-actions-menu-item-${id}`;

export const NAVBAR_VOICEBOX_ADD_NEW_BUTTON = 'navbar-voicebox-add-new-button';
export const NAVBAR_VOICEBOX_CHAT_LIST_BUTTON =
  'navbar-voicebox-chat-list-button';
export const NAVBAR_VOICEBOX_CHAT_LIST_LATEST_ITEM = (
  id: string,
  idx?: number
) => `navbar-voicebox-chat-list-latest-item-${getTestId(id, idx)}`;
export const NAVBAR_VOICEBOX_SETTINGS_BUTTON =
  'navbar-voicebox-settings-button';

export const PORTAL_ENDPOINT_ASIDE_MANAGE_ENDPOINTS =
  'portal-endpoint-aside-manage-endpoints';
export const PORTAL_ENDPOINT_ASIDE_SELECTOR = 'portal-endpoint-aside-selector';
export const PORTAL_ENDPOINT_ASIDE_SELECTOR_ITEM = (id: string, idx?: number) =>
  `portal-endpoint-aside-selector-item-${getTestId(id, idx)}`;

export const VOICEBOX_CHAT_LIST_ASIDE_INPUT = 'voicebox-chat-list-aside-input';
export const VOICEBOX_CHAT_LIST_ASIDE_INPUT_CLEAR =
  'voicebox-chat-list-aside-input-clear';
export const VOICEBOX_CHAT_LIST_ITEM_BUTTON = (id: string, idx?: number) =>
  `voicebox-chat-list-item-button-${getTestId(id, idx)}`;
export const VOICEBOX_CHAT_LIST_ITEM_DIVIDER = (id: string, idx?: number) =>
  `voicebox-chat-list-item-divider-${getTestId(id, idx)}`;
export const VOICEBOX_CHAT_LIST_ITEM_MENU_BUTTON =
  'voicebox-chat-list-item-menu-button';
export const VOICEBOX_CHAT_LIST_ITEM_RENAME_MENU_ITEM =
  'voicebox-chat-list-item-rename-menu-item';
export const VOICEBOX_CHAT_LIST_ITEM_RENAME_INPUT =
  'voicebox-chat-list-item-rename-input';
export const VOICEBOX_CHAT_LIST_ITEM_DELETE_MENU_ITEM =
  'voicebox-chat-list-item-delete-menu-item';
export const VOICEBOX_CHAT_LIST_ITEM_DELETE_CONFIRMATION =
  'voicebox-chat-list-item-delete-confirmation';
export const VOICEBOX_CHAT_LIST_ITEM_DELETE_CANCEL =
  'voicebox-chat-list-item-delete-cancel';

export const VOICEBOX_PAGE_DRAWER_BODY_CONTAINER =
  'voicebox-page-drawer-body-container';

export const INTERNAL_HOME_ACTION_SEARCH = 'internal-home-action-search';
export const INTERNAL_HOME_VERSION_DISPLAY = 'internal-home-version-display';
export const INTERNAL_USER_SEARCH = 'internal-user-search';
export const INTERNAL_USER_SEARCH_DOWNLOAD = 'internal-user-search-download';
export const INTERNAL_USER_SEARCH_FILTER = (id: string) =>
  `internal-user-search-filter-${id}`;
export const INTERNAL_USER_DASHBOARD_CLOUDS = 'internal-user-dashboard-clouds';
export const INTERNAL_USER_DASHBOARD_FEATURE_TOGGLE = (id: string) =>
  `internal-user-dashboard-feature-toggle-${id}`;
export const INTERNAL_USER_DASHBOARD_BACK_TO_SEARCH =
  'internal-user-dashboard-back-to-search';
export const DELETE_ACCOUNT_DIALOG_DELETE_ACCOUNT_BUTTON =
  'delete-account-dialog-delete-account-button';
export const DELETE_ACCOUNT_DIALOG_CONFIRMATION_INPUT =
  'delete-account-dialog-delete-account-input';

export const INVITATION_DIALOG_NAME_INPUT = 'invitation-dialog-name-input';
export const INVITATION_DIALOG_SUBMIT = 'invitation-dialog-submit';
export const INVITATION_DIALOG_CANCEL = 'invitation-dialog-cancel';

export const VERIFY_EMAIL_DIALOG_RESEND_BUTTON =
  'verify-email-dialog-resend-button';

export const LAUNCHPAD_LOGIN_SHARED_USER_AUTH_SUBMIT_BUTTON =
  'launchpad-login-shared-user-auth-submit-button';
export const LAUNCHPAD_LOGIN_KERBEROS_AUTH_SUBMIT_BUTTON =
  'launchpad-login-kerberos-auth-submit-button';

export const LAUNCHPAD_ADD_BASIC_CONNECTION_BUTTON =
  'launchpad-add-basic-connection-button';
export const LAUNCHPAD_ADD_SSO_CONNECTION_BUTTON =
  'launchpad-add-sso-connection-button';
export const LAUNCHPAD_COPY_ENDPOINT_BUTTON = 'launchpad-copy-endpoint-button';
export const LAUNCHPAD_COPY_TOKEN_BUTTON = 'launchpad-copy-token-button';
export const LAUNCHPAD_CONNECTION_SSO_BADGE = 'launchpad-connection-sso-badge';
export const LAUNCHPAD_CONNECTION_SSO_PROVIDER_WARNING =
  'launchpad-connection-sso-provider-warning';
export const LAUNCHPAD_CONNECTION_SSO_DELETE_BUTTON =
  'launchpad-connection-sso-delete-button';
export const LAUNCHPAD_CONNECTION_EXPANDED_INFO =
  'launchpad-connection-expanded-info';
export const LAUNCHPAD_CONNECTION_BASIC_AUTH_FAILURE_CALLOUT =
  'launchpad-connection-basic-auth-failure-callout';
export const LAUNCHPAD_CONNECTION_SSO_AUTH_FAILURE_NO_TOKEN_CALLOUT =
  'launchpad-connection-sso-auth-failure-no-token-callout';
export const LAUNCHPAD_CONNECTION_SSO_AUTH_FAILURE_EXISTING_TOKEN_CALLOUT =
  'launchpad-connection-sso-auth-failure-existing-token-callout';
export const LAUNCHPAD_CONNECTION_BROWSER_AUTH_FAILURE_CALLOUT =
  'launchpad-connection-browser-auth-failure-callout';
export const LAUNCHPAD_CONNECTION_REAUTHENTICATE_BUTTON =
  'launchpad-connection-reauthenticate-button';

export const CLOUD_REPORT_QUEUE_MICRO_COUNT = 'cloud-report-queue-micro-count';
export const CLOUD_REPORT_QUEUE_SMALL_VBX_COUNT =
  'cloud-report-queue-small-vbx-count';
export const CLOUD_REPORT_QUEUE_MEDIUM_COUNT =
  'cloud-report-queue-medium-count';
export const CLOUD_REPORT_TABLE = 'cloud-report-table';
export const CLOUD_REPORT_FILTERS_CONTAINER = 'cloud-report-filters-container';
export const CLOUD_REPORT_INACTIVE_FILTER = 'cloud-report-inactive-filter';
export const CLOUD_REPORT_SEARCH_BUTTON = 'cloud-report-search-button';
export const CLOUD_REPORT_DAYS_SEARCH_BUTTON =
  'cloud-report-days-search-button';
export const CLOUD_REPORT_SDU_DOWNLOAD_BUTTON = (id: string, idx?: number) =>
  `cloud-report-sdu-download-button-${getTestId(id, idx)}`;
export const CLOUD_REPORT_MOVE_TO_ORG_BUTTON = (id: string, idx?: number) =>
  `cloud-report-move-to-org-button-${getTestId(id, idx)}`;
export const CLOUD_REPORT_MOVE_DIALOG = 'cloud-report-move-dialog';
export const CLOUD_REPORT_MOVE_INELIGIBLE = 'cloud-report-move-ineligible';
export const CLOUD_REPORT_MOVE_TARGET_ORG_INPUT =
  'cloud-report-move-target-org-input';
export const CLOUD_REPORT_MOVE_VISIBILITY_ORG_WIDE =
  'cloud-report-move-visibility-org-wide';
export const CLOUD_REPORT_MOVE_VISIBILITY_RESTRICTED =
  'cloud-report-move-visibility-restricted';
export const CLOUD_REPORT_MOVE_ACCESS_TOGGLE = (email: string, idx?: number) =>
  `cloud-report-move-access-toggle-${getTestId(email, idx)}`;
export const CLOUD_REPORT_MOVE_ROLE_SELECT = (email: string, idx?: number) =>
  `cloud-report-move-role-select-${getTestId(email, idx)}`;
export const CLOUD_REPORT_MOVE_ADD_ME = 'cloud-report-move-add-me';
export const CLOUD_REPORT_MOVE_MEMBERS = 'cloud-report-move-members';
export const CLOUD_REPORT_MOVE_MEMBER = (email: string, idx?: number) =>
  `cloud-report-move-member-${getTestId(email, idx)}`;
export const CLOUD_REPORT_MOVE_ACCESS_LIST = 'cloud-report-move-access-list';
export const CLOUD_REPORT_MOVE_INVALID_ORG = 'cloud-report-move-invalid-org';
export const CLOUD_REPORT_MOVE_ALREADY_MEMBER = (email: string, idx?: number) =>
  `cloud-report-move-already-member-${getTestId(email, idx)}`;
export const CLOUD_REPORT_MOVE_KEEP_SOURCE = 'cloud-report-move-keep-source';
export const CLOUD_REPORT_MOVE_MULTIPLE_CONNECTIONS =
  'cloud-report-move-multiple-connections';
export const CLOUD_REPORT_CLEANUP_BUTTON = (id: string, idx?: number) =>
  `cloud-report-cleanup-button-${getTestId(id, idx)}`;
export const CLOUD_REPORT_CLEANUP_DIALOG = 'cloud-report-cleanup-dialog';
export const CLOUD_REPORT_CLEANUP_NOT_MOVED = 'cloud-report-cleanup-not-moved';
export const CLOUD_REPORT_CLEANUP_EMPTY = 'cloud-report-cleanup-empty';
export const CLOUD_REPORT_CLEANUP_ORPHAN_LIST =
  'cloud-report-cleanup-orphan-list';
export const CLOUD_REPORT_CLEANUP_ACTION_SELECT = (
  connectionId: string,
  idx?: number
) => `cloud-report-cleanup-action-select-${getTestId(connectionId, idx)}`;
export const CLOUD_REPORT_CLEANUP_ROLE_SELECT = (
  connectionId: string,
  idx?: number
) => `cloud-report-cleanup-role-select-${getTestId(connectionId, idx)}`;
export const CLOUD_REPORT_CLEANUP_MEMBERS_WITHOUT =
  'cloud-report-cleanup-members-without';
export const CLOUD_REPORT_TRANSFER_BUTTON = (id: string, idx?: number) =>
  `cloud-report-transfer-button-${getTestId(id, idx)}`;
export const CLOUD_REPORT_TRANSFER_DIALOG = 'cloud-report-transfer-dialog';
export const CLOUD_REPORT_TRANSFER_INELIGIBLE =
  'cloud-report-transfer-ineligible';
export const CLOUD_REPORT_TRANSFER_TARGET_USER_INPUT =
  'cloud-report-transfer-target-user-input';
export const CLOUD_REPORT_TRANSFER_USER_NOT_FOUND =
  'cloud-report-transfer-user-not-found';
export const CLOUD_REPORT_TRANSFER_DESTINATION_SELECT =
  'cloud-report-transfer-destination-select';
export const CLOUD_REPORT_TRANSFER_DESTINATION_NEW =
  'cloud-report-transfer-destination-new';
export const CLOUD_REPORT_TRANSFER_CARRIED_LIST =
  'cloud-report-transfer-carried-list';
export const CLOUD_REPORT_TRANSFER_OWNER = 'cloud-report-transfer-owner';
export const CLOUD_REPORT_TRANSFER_ACCESS_ACTION = (
  email: string,
  idx?: number
) => `cloud-report-transfer-access-action-${getTestId(email, idx)}`;
export const CLOUD_REPORT_TRANSFER_OTHER_LIST =
  'cloud-report-transfer-other-list';
export const CLOUD_REPORT_VALIDATION_WARNING =
  'cloud-report-validation-warning';

export const CONNECTION_FORM_ADVANCED_OPTIONS_BUTTON =
  'connection-form-advanced-options-button';
export const CONNECTION_FORM_INTERNAL_ENDPOINT_INPUT =
  'connection-form-internal-endpoint-input';

export const VERIFY_EMAIL_PAGE = 'verify-email-page';
export const VERIFY_EMAIL_PAGE_RESEND_BUTTON =
  'verify-email-page-resend-button';
export const VERIFY_EMAIL_PAGE_RESEND_MESSAGE =
  'verify-email-page-resend-message';
export const VERIFY_EMAIL_PAGE_BACK_TO_LOGIN =
  'verify-email-page-back-to-login';
export const VERIFY_EMAIL_PAGE_CONTACT_US = 'verify-email-page-contact-us';

export const LOGIN_CARD = 'login-card';
export const LOGIN_AUTH0 = 'login-auth0';
export const LOGIN_ORG_INPUT = 'login-org-input';
export const LOGIN_SSO_SUBMIT = 'login-sso-submit';
export const LOGIN_ORG_PROVIDER_CARD = 'login-org-provider-card';
export const LOGIN_PROVIDER_BUTTON = 'login-provider-button';
export const LOGIN_BACK = 'login-back';
export const LOGIN_LOOKUP_ERROR = 'login-lookup-error';
export const LOGIN_URL_ERROR = 'login-url-error';

export const VERIFY_CHALLENGE_CODE_INPUT = 'verify-challenge-code-input';
export const VERIFY_CHALLENGE_SUBMIT = 'verify-challenge-submit';
export const VERIFY_CHALLENGE_RESEND = 'verify-challenge-resend';
export const VERIFY_CHALLENGE_BACK = 'verify-challenge-back';

export const ADD_ORGANIZATION_DIALOG_CANCEL = 'add-organization-dialog-cancel';
export const ADD_ORGANIZATION_DIALOG_SUBMIT = 'add-organization-dialog-submit';
export const ADD_ORGANIZATION_DIALOG_NAME_INPUT =
  'add-organization-dialog-name-input';
export const ADD_ORGANIZATION_DIALOG_DESCRIPTION_INPUT =
  'add-organization-dialog-description-input';
export const ADD_ORGANIZATION_DIALOG_DOMAIN_INPUT =
  'add-organization-dialog-domain-input';
export const ADD_ORGANIZATION_DIALOG_ADMINS_ADD =
  'add-organization-dialog-admins-add';
export const ADD_ORGANIZATION_DIALOG_ADMINS_CHIP_ITEM = (
  id: string,
  idx?: number
) => `add-organization-dialog-admins-chip-item-${getTestId(id, idx)}`;
export const ADD_ORGANIZATION_DIALOG_ADMINS_CHIP_REMOVE = (
  id: string,
  idx?: number
) => `add-organization-dialog-admins-chip-remove-${getTestId(id, idx)}`;
export const ADD_ORGANIZATION_DIALOG_ADMINS_INPUT =
  'add-organization-dialog-admins-input';

export const DELETE_ORGANIZATION_DIALOG_CANCEL =
  'delete-organization-dialog-cancel';
export const DELETE_ORGANIZATION_DIALOG_SUBMIT =
  'delete-organization-dialog-submit';
export const DELETE_ORGANIZATION_DIALOG_INPUT =
  'delete-organization-dialog-input';

export const EDIT_ORGANIZATION_DIALOG_CANCEL =
  'edit-organization-dialog-cancel';
export const EDIT_ORGANIZATION_DIALOG_SUBMIT =
  'edit-organization-dialog-submit';
export const EDIT_ORGANIZATION_DIALOG_NAME_INPUT =
  'edit-organization-dialog-name-input';
export const EDIT_ORGANIZATION_DIALOG_DESCRIPTION_INPUT =
  'edit-organization-dialog-description-input';
export const EDIT_ORGANIZATION_DIALOG_SELECTOR_CHIP_ITEM = (
  id: string,
  idx?: number
) => `edit-organization-dialog-selector-chip-item-${getTestId(id, idx)}`;
export const EDIT_ORGANIZATION_DIALOG_SELECTOR_CHIP_BUTTON = (
  id: string,
  idx?: number
) => `edit-organization-dialog-selector-chip-button-${getTestId(id, idx)}`;
export const EDIT_ORGANIZATION_DIALOG_SELECTOR_FILTER =
  'edit-organization-dialog-selector-filter';
export const EDIT_ORGANIZATION_DIALOG_SELECTOR_INPUT =
  'edit-organization-dialog-selector-input';
export const EDIT_ORGANIZATION_DIALOG_SELECTOR_ITEM = (
  id: string,
  idx?: number
) => `edit-organization-dialog-selector-item-${getTestId(id, idx)}`;

export const TRANSFER_ORGANIZATION_DIALOG_CANCEL =
  'transfer-organization-dialog-cancel';
export const TRANSFER_ORGANIZATION_DIALOG_SUBMIT =
  'transfer-organization-dialog-submit';
export const TRANSFER_ORGANIZATION_DIALOG_SELECTOR =
  'transfer-organization-dialog-selector';
export const TRANSFER_ORGANIZATION_DIALOG_SELECTOR_ITEM = (
  id: string,
  idx?: number
) => `transfer-organization-dialog-selector-item-${getTestId(id, idx)}`;

export const LEAVE_ORGANIZATION_DIALOG_CANCEL =
  'leave-organization-dialog-cancel';
export const LEAVE_ORGANIZATION_DIALOG_SUBMIT =
  'leave-organization-dialog-submit';
export const LEAVE_ORGANIZATION_DIALOG_SELECTOR =
  'leave-organization-dialog-selector';
export const LEAVE_ORGANIZATION_DIALOG_SELECTOR_ITEM = (
  id: string,
  idx?: number
) => `leave-organization-dialog-selector-item-${getTestId(id, idx)}`;

export const INVITE_ORGANIZATION_DIALOG_CANCEL =
  'invite-organization-dialog-cancel';
export const INVITE_ORGANIZATION_DIALOG_NEXT =
  'invite-organization-dialog-next';
export const INVITE_ORGANIZATION_DIALOG_BACK =
  'invite-organization-dialog-back';
export const INVITE_ORGANIZATION_DIALOG_SUBMIT =
  'invite-organization-dialog-submit';
export const INVITE_ORGANIZATION_DIALOG_EMAILS_INPUT =
  'invite-organization-dialog-emails-input';
export const INVITE_ORGANIZATION_DIALOG_EMAILS_ADD =
  'invite-organization-dialog-emails-add';
export const INVITE_ORGANIZATION_DIALOG_ROLE_ADMIN =
  'invite-organization-dialog-role-admin';
export const INVITE_ORGANIZATION_DIALOG_ROLE_MEMBER =
  'invite-organization-dialog-role-member';
export const INVITE_ORGANIZATION_DIALOG_CONNECTIONS_SELECT =
  'invite-organization-dialog-connections-select';
export const INVITE_ORGANIZATION_DIALOG_CONNECTIONS_DEFAULT =
  'invite-organization-dialog-connections-default';
export const INVITE_ORGANIZATION_DIALOG_CONNECTIONS_SEARCH =
  'invite-organization-dialog-connections-search';
export const INVITE_ORGANIZATION_DIALOG_CONNECTION_CHECKBOX = (
  id: string,
  idx?: number
) => `invite-organization-dialog-connection-checkbox-${getTestId(id, idx)}`;
export const INVITE_ORGANIZATION_DIALOG_CONNECTION_ROLES = (
  id: string,
  idx?: number
) => `invite-organization-dialog-connection-roles-${getTestId(id, idx)}`;
export const INVITE_ORGANIZATION_DIALOG_CONNECTION_ROLE_ITEM = (
  value: string,
  idx?: number
) => `invite-organization-dialog-connection-role-item-${getTestId(value, idx)}`;
export const INVITE_ORGANIZATION_DIALOG_CONNECTIONS_SEARCH_CLEAR =
  'invite-organization-dialog-connections-search-clear';
export const INVITE_ORGANIZATION_DIALOG_EMAILS_CHIP_REMOVE = (
  tag: string,
  idx?: number
) => `invite-organization-dialog-emails-chip-remove-${getTestId(tag, idx)}`;

export const ORGANIZATION_DASHBOARD_CONTAINER =
  'organization-dashboard-container';
export const ORGANIZATION_DASHBOARD_ENDPOINTS_HEADING =
  'organization-endpoints-heading';
export const ORGANIZATION_DASHBOARD_ENDPOINT_HEADING =
  'organization-endpoint-heading';
export const ORGANIZATION_DASHBOARD_BREADCRUMB_ORG =
  'organization-dashboard-breadcrumb-org';
export const ORGANIZATION_DASHBOARD_BREADCRUMB_ENDPOINTS =
  'organization-endpoint-breadcrumb-endpoints';
export const ORGANIZATION_DASHBOARD_CARD_ENDPOINTS =
  'organization-dashboard-card-endpoints';
export const ORGANIZATION_DASHBOARD_CARD_MEMBERS =
  'organization-dashboard-card-members';
export const ORGANIZATION_DASHBOARD_CARD_UNITS =
  'organization-dashboard-card-units';
export const ORGANIZATION_DASHBOARD_INVITE_MEMBER =
  'organization-dashboard-invite-member';
export const ORGANIZATION_DASHBOARD_MEMBER_VISIBILITY_NOTICE =
  'organization-dashboard-member-visibility-notice';
export const ORGANIZATION_DASHBOARD_MENU = 'organization-dashboard-menu';
export const ORGANIZATION_DASHBOARD_MENU_EDIT =
  'organization-dashboard-menu-edit';
export const ORGANIZATION_DASHBOARD_MENU_SSO =
  'organization-dashboard-menu-sso';
export const ORGANIZATION_DASHBOARD_MENU_TRANSFER =
  'organization-dashboard-menu-transfer';
export const ORGANIZATION_DASHBOARD_MENU_LEAVE =
  'organization-dashboard-menu-leave';
export const ORGANIZATION_DASHBOARD_MENU_DELETE =
  'organization-dashboard-menu-delete';

export const ORGANIZATION_SDU_DASHBOARD_HEADING =
  'organization-sdu-dashboard-heading';
export const ORGANIZATION_SDU_DASHBOARD_ENDPOINT_HEADING =
  'organization-sdu-dashboard-endpoint-heading';
export const ORGANIZATION_SDU_DASHBOARD_BREADCRUMB_UNITS =
  'organization-sdu-dashboard-breadcrumb-units';

export const ORGANIZATION_MEMBER_TABLE_SEARCH =
  'organization-member-table-search';
export const ORGANIZATION_MEMBER_TABLE_CONFIRMATION_YES =
  'organization-member-table-confirmation-yes';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_NAME =
  'organization-member-table-column-name';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_NAME_SORT =
  'organization-member-table-column-name-sort';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_ROLE =
  'organization-member-table-column-role';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_ROLE_SORT =
  'organization-member-table-column-role-sort';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_STATUS =
  'organization-member-table-column-status';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_STATUS_SORT =
  'organization-member-table-column-status-sort';
export const ORGANIZATION_MEMBER_TABLE_COLUMN_ACTIONS =
  'organization-member-table-column-actions';
export const ORGANIZATION_MEMBER_TABLE_ROW_NAME = (id: string, idx?: number) =>
  `organization-member-table-row-name-${getTestId(id, idx)}`;
export const ORGANIZATION_MEMBER_TABLE_ROW_ACTIONS = (
  id: string,
  idx?: number
) => `organization-member-table-row-actions-${getTestId(id, idx)}`;
export const ORGANIZATION_MEMBER_TABLE_ROW_ACTIONS_MENU =
  'organization-member-table-row-actions-menu';
export const ORGANIZATION_MEMBER_TABLE_ROW_ACTIONS_MENU_ITEM = (id: string) =>
  `organization-member-table-row-actions-menu-item-${id}`;

// Portal Endpoints Dashboard
export const PORTAL_ENDPOINTS_HEADING = 'portal-endpoints-heading';
export const PORTAL_ENDPOINTS_ADD_EXISTING = 'portal-endpoints-add-existing';
export const PORTAL_ENDPOINTS_ADD_CLOUD = 'portal-endpoints-add-cloud';

// Portal Endpoint Table
export const PORTAL_ENDPOINT_TABLE_SEARCH = 'portal-endpoint-table-search';
export const PORTAL_ENDPOINT_TABLE_COLUMN_SORT = (key: string) =>
  `portal-endpoint-table-column-sort-${key}`;
export const PORTAL_ENDPOINT_TABLE_ROW_NAME = (id: string, idx?: number) =>
  `portal-endpoint-table-row-name-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_TABLE_ROW_ACTIONS_MENU = (
  id: string,
  idx?: number
) => `portal-endpoint-table-row-actions-menu-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_TABLE_ROW_ACTIONS_MENU_ITEM = (id: string) =>
  `portal-endpoint-table-row-actions-menu-item-${id}`;
export const PORTAL_ENDPOINT_TABLE_CONFIRMATION_YES =
  'portal-endpoint-table-confirmation-yes';

// Portal Endpoint Dashboard
export const PORTAL_ENDPOINT_HEADING = 'portal-endpoint-heading';
export const PORTAL_ENDPOINT_BREADCRUMB_ENDPOINTS =
  'portal-endpoint-breadcrumb-endpoints';

// Portal Endpoint User Table
export const PORTAL_ENDPOINT_USER_TABLE_SEARCH =
  'portal-endpoint-user-table-search';
export const PORTAL_ENDPOINT_USER_TABLE_ADD = 'portal-endpoint-user-table-add';
export const PORTAL_ENDPOINT_USER_TABLE_CONFIRMATION_YES =
  'portal-endpoint-user-table-confirmation-yes';
export const PORTAL_ENDPOINT_USER_TABLE_COLUMN_ROLE =
  'portal-endpoint-user-table-column-role';
export const PORTAL_ENDPOINT_USER_TABLE_ROW_NAME = (id: string, idx?: number) =>
  `portal-endpoint-user-table-row-name-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_USER_TABLE_ROW_AVATAR = (
  id: string,
  idx?: number
) => `portal-endpoint-user-table-row-avatar-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_USER_TABLE_ROW_ROLE = (id: string, idx?: number) =>
  `portal-endpoint-user-table-row-role-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_USER_TABLE_ROW_STATUS = (
  id: string,
  idx?: number
) => `portal-endpoint-user-table-row-status-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_USER_TABLE_ROW_ACTIONS_MENU = (
  id: string,
  idx?: number
) => `portal-endpoint-user-table-row-actions-menu-${getTestId(id, idx)}`;
export const PORTAL_ENDPOINT_USER_TABLE_ROW_ACTIONS_MENU_ITEM = (id: string) =>
  `portal-endpoint-user-table-row-actions-menu-item-${id}`;

// Launchpad Endpoints Dashboard
export const LAUNCHPAD_ENDPOINTS_HEADING = 'launchpad-endpoints-heading';
export const LAUNCHPAD_ENDPOINTS_ADD_EXISTING =
  'launchpad-endpoints-add-existing';
export const LAUNCHPAD_ENDPOINTS_ADD_SSO = 'launchpad-endpoints-add-sso';

// Launchpad Endpoint Table
export const LAUNCHPAD_ENDPOINT_TABLE_SEARCH =
  'launchpad-endpoint-table-search';
export const LAUNCHPAD_ENDPOINT_TABLE_COLUMN_SORT = (key: string) =>
  `launchpad-endpoint-table-column-sort-${key}`;
export const LAUNCHPAD_ENDPOINT_TABLE_ROW_NAME = (id: string, idx?: number) =>
  `launchpad-endpoint-table-row-name-${getTestId(id, idx)}`;
export const LAUNCHPAD_ENDPOINT_TABLE_ROW_ACTIONS_MENU = (
  id: string,
  idx?: number
) => `launchpad-endpoint-table-row-actions-menu-${getTestId(id, idx)}`;
export const LAUNCHPAD_ENDPOINT_TABLE_ROW_ACTIONS_MENU_ITEM = (id: string) =>
  `launchpad-endpoint-table-row-actions-menu-item-${id}`;
export const LAUNCHPAD_ENDPOINT_TABLE_ROW_SSO_REQUIRED_WARNING = (
  id: string,
  idx?: number
) => `launchpad-endpoint-table-row-sso-required-warning-${getTestId(id, idx)}`;

// Organization Endpoint Table
export const ORGANIZATION_ENDPOINT_TABLE_SEARCH =
  'organization-endpoint-table-search';
export const ORGANIZATION_ENDPOINT_TABLE_ADD =
  'organization-endpoint-table-add';
export const ORGANIZATION_ENDPOINT_TABLE_COLUMN_SORT = (key: string) =>
  `organization-endpoint-table-column-sort-${key}`;
export const ORGANIZATION_ENDPOINT_TABLE_ROW_NAME = (
  id: string,
  idx?: number
) => `organization-endpoint-table-row-name-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_TABLE_ROW_ACTIONS_MENU = (
  id: string,
  idx?: number
) => `organization-endpoint-table-row-actions-menu-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_TABLE_ROW_ACTIONS_MENU_ITEM = (id: string) =>
  `organization-endpoint-table-row-actions-menu-item-${id}`;

// Organization Endpoint User Table
export const ORGANIZATION_ENDPOINT_USER_TABLE_SEARCH =
  'organization-endpoint-user-table-search';
export const ORGANIZATION_ENDPOINT_USER_TABLE_ADD =
  'organization-endpoint-user-table-add';
export const ORGANIZATION_ENDPOINT_USER_TABLE_CONFIRMATION_YES =
  'organization-endpoint-user-table-confirmation-yes';
export const ORGANIZATION_ENDPOINT_USER_TABLE_COLUMN_ROLE =
  'organization-endpoint-user-table-column-role';
export const ORGANIZATION_ENDPOINT_USER_TABLE_ROW_NAME = (
  id: string,
  idx?: number
) => `organization-endpoint-user-table-row-name-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_USER_TABLE_ROW_AVATAR = (
  id: string,
  idx?: number
) => `organization-endpoint-user-table-row-avatar-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_USER_TABLE_ROW_ROLE = (
  id: string,
  idx?: number
) => `organization-endpoint-user-table-row-role-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_USER_TABLE_ROW_ACTIONS_MENU = (
  id: string,
  idx?: number
) => `organization-endpoint-user-table-row-actions-menu-${getTestId(id, idx)}`;
export const ORGANIZATION_ENDPOINT_USER_TABLE_ROW_ACTIONS_MENU_ITEM = (
  id: string
) => `organization-endpoint-user-table-row-actions-menu-item-${id}`;

// Configure Organization SSO Dialog
export const CONFIGURE_ORG_SSO_DIALOG_PROVIDER_OKTA =
  'configure-org-sso-dialog-provider-okta';
export const CONFIGURE_ORG_SSO_DIALOG_PROVIDER_ENTRA =
  'configure-org-sso-dialog-provider-entra';
export const CONFIGURE_ORG_SSO_DIALOG_CANCEL =
  'configure-org-sso-dialog-cancel';
export const CONFIGURE_ORG_SSO_DIALOG_SUBMIT =
  'configure-org-sso-dialog-submit';

// Form inputs (shared between Okta and Entra create/edit)
export const CONFIGURE_ORG_SSO_DIALOG_DISCOVERY_URL =
  'configure-org-sso-dialog-discovery-url';
export const CONFIGURE_ORG_SSO_DIALOG_CLIENT_ID =
  'configure-org-sso-dialog-client-id';
export const CONFIGURE_ORG_SSO_DIALOG_CLIENT_SECRET =
  'configure-org-sso-dialog-client-secret';
export const CONFIGURE_ORG_SSO_DIALOG_CLIENT_SECRET_VIEW =
  'configure-org-sso-dialog-client-secret-view';
export const CONFIGURE_ORG_SSO_DIALOG_CLIENT_SECRET_REPLACE =
  'configure-org-sso-dialog-client-secret-replace';
export const CONFIGURE_ORG_SSO_DIALOG_IDP_LOGOUT =
  'configure-org-sso-dialog-idp-logout';

// Okta-specific inputs
export const CONFIGURE_ORG_SSO_DIALOG_OKTA_AUDIENCE =
  'configure-org-sso-dialog-okta-audience';
export const CONFIGURE_ORG_SSO_DIALOG_OKTA_BACKEND_CLIENT_ID =
  'configure-org-sso-dialog-okta-backend-client-id';
export const CONFIGURE_ORG_SSO_DIALOG_OKTA_BACKEND_CLIENT_SECRET =
  'configure-org-sso-dialog-okta-backend-client-secret';
export const CONFIGURE_ORG_SSO_DIALOG_OKTA_BACKEND_CLIENT_SECRET_VIEW =
  'configure-org-sso-dialog-okta-backend-client-secret-view';
export const CONFIGURE_ORG_SSO_DIALOG_OKTA_BACKEND_CLIENT_SECRET_REPLACE =
  'configure-org-sso-dialog-okta-backend-client-secret-replace';

// View mode
export const CONFIGURE_ORG_SSO_DIALOG_LOGIN_URL =
  'configure-org-sso-dialog-login-url';
export const CONFIGURE_ORG_SSO_DIALOG_LOGIN_URL_COPY =
  'configure-org-sso-dialog-login-url-copy';
export const CONFIGURE_ORG_SSO_DIALOG_REDIRECT_URI =
  'configure-org-sso-dialog-redirect-uri';
export const CONFIGURE_ORG_SSO_DIALOG_REDIRECT_URI_COPY =
  'configure-org-sso-dialog-redirect-uri-copy';
export const CONFIGURE_ORG_SSO_DIALOG_POST_LOGOUT_URI =
  'configure-org-sso-dialog-post-logout-uri';
export const CONFIGURE_ORG_SSO_DIALOG_POST_LOGOUT_URI_COPY =
  'configure-org-sso-dialog-post-logout-uri-copy';
export const CONFIGURE_ORG_SSO_DIALOG_EDIT = 'configure-org-sso-dialog-edit';
export const CONFIGURE_ORG_SSO_DIALOG_DELETE =
  'configure-org-sso-dialog-delete';
export const CONFIGURE_ORG_SSO_DIALOG_DELETE_CONFIRM =
  'configure-org-sso-dialog-delete-confirm';
export const CONFIGURE_ORG_SSO_DIALOG_DELETE_CANCEL =
  'configure-org-sso-dialog-delete-cancel';

export const ADD_ENDPOINT_DIALOG_SUBMIT = 'add-endpoint-dialog-submit';
export const ADD_ENDPOINT_DIALOG_CANCEL = 'add-endpoint-dialog-cancel';
export const ADD_ENDPOINT_DIALOG_NAME = 'add-endpoint-dialog-name';
export const ADD_ENDPOINT_DIALOG_ENDPOINT = 'add-endpoint-dialog-endpoint';
export const ADD_ENDPOINT_DIALOG_INTERNAL_ENDPOINT =
  'add-endpoint-dialog-internal-endpoint';
export const ADD_ENDPOINT_DIALOG_USE_SSO = 'add-endpoint-dialog-use-sso';
export const ADD_ENDPOINT_DIALOG_USERNAME = 'add-endpoint-dialog-username';
export const ADD_ENDPOINT_DIALOG_PASSWORD = 'add-endpoint-dialog-password';

export const SIGN_IN_DIALOG_CLOSE = 'sign-in-dialog-close';
export const SIGN_IN_DIALOG_USERNAME = 'sign-in-dialog-username';
export const SIGN_IN_DIALOG_PASSWORD = 'sign-in-dialog-password';
export const SIGN_IN_DIALOG_SUBMIT = 'sign-in-dialog-submit';
export const SIGN_IN_DIALOG_SUBMIT_LOADING = 'sign-in-dialog-submit-loading';
export const SIGN_IN_DIALOG_SSO_REQUIRED = 'sign-in-dialog-sso-required';

export const CANCEL_ENDPOINT_DIALOG_SUBMIT = 'cancel-endpoint-dialog-submit';
export const CANCEL_ENDPOINT_DIALOG_CANCEL = 'cancel-endpoint-dialog-cancel';
export const CANCEL_ENDPOINT_DIALOG_INPUT = 'cancel-endpoint-dialog-input';

export const DELETE_ENDPOINT_DIALOG_SUBMIT = 'delete-endpoint-dialog-submit';
export const DELETE_ENDPOINT_DIALOG_CANCEL = 'delete-endpoint-dialog-cancel';
export const DELETE_ENDPOINT_DIALOG_INPUT = 'delete-endpoint-dialog-input';

export const EDIT_ENDPOINT_DIALOG_SUBMIT = 'edit-endpoint-dialog-submit';
export const EDIT_ENDPOINT_DIALOG_CANCEL = 'edit-endpoint-dialog-cancel';
export const EDIT_ENDPOINT_DIALOG_NAME = 'edit-endpoint-dialog-name';
export const EDIT_ENDPOINT_DIALOG_ENDPOINT = 'edit-endpoint-dialog-endpoint';
export const EDIT_ENDPOINT_DIALOG_INTERNAL_ENDPOINT =
  'edit-endpoint-dialog-internal-endpoint';
export const EDIT_ENDPOINT_DIALOG_USERNAME = 'edit-endpoint-dialog-username';
export const EDIT_ENDPOINT_DIALOG_PASSWORD = 'edit-endpoint-dialog-password';
export const EDIT_ENDPOINT_DIALOG_IS_DEFAULT =
  'edit-endpoint-dialog-is-default';
export const EDIT_ENDPOINT_DIALOG_USE_SSO = 'edit-endpoint-dialog-use-sso';
export const EDIT_ENDPOINT_DIALOG_SSO_SCOPE = 'edit-endpoint-dialog-sso-scope';
export const EDIT_ENDPOINT_DIALOG_ROLES = 'edit-endpoint-dialog-roles';
export const EDIT_ENDPOINT_DIALOG_ROLES_CHIP = (id: string, idx?: number) =>
  `edit-endpoint-dialog-roles-chip-${getTestId(id, idx)}`;
export const EDIT_ENDPOINT_DIALOG_ROLES_ITEM = (id: string, idx?: number) =>
  `edit-endpoint-dialog-roles-item-${getTestId(id, idx)}`;

export const EDIT_MY_ORG_ENDPOINT_DIALOG_SUBMIT =
  'edit-my-org-endpoint-dialog-submit';
export const EDIT_MY_ORG_ENDPOINT_DIALOG_CANCEL =
  'edit-my-org-endpoint-dialog-cancel';
export const EDIT_MY_ORG_ENDPOINT_DIALOG_NAME =
  'edit-my-org-endpoint-dialog-name';
export const EDIT_MY_ORG_ENDPOINT_DIALOG_ENDPOINT =
  'edit-my-org-endpoint-dialog-endpoint';
export const EDIT_MY_ORG_ENDPOINT_DIALOG_USERNAME =
  'edit-my-org-endpoint-dialog-username';
export const EDIT_MY_ORG_ENDPOINT_DIALOG_PASSWORD =
  'edit-my-org-endpoint-dialog-password';

export const ADD_MY_ORG_ENDPOINT_DIALOG_SUBMIT =
  'add-my-org-endpoint-dialog-submit';
export const ADD_MY_ORG_ENDPOINT_DIALOG_CANCEL =
  'add-my-org-endpoint-dialog-cancel';
export const ADD_MY_ORG_ENDPOINT_DIALOG_NAME =
  'add-my-org-endpoint-dialog-name';
export const ADD_MY_ORG_ENDPOINT_DIALOG_ENDPOINT =
  'add-my-org-endpoint-dialog-endpoint';
export const ADD_MY_ORG_ENDPOINT_DIALOG_ENDPOINT_ITEM = (
  id: string,
  idx?: number
) => `add-my-org-endpoint-dialog-endpoint-item-${getTestId(id, idx)}`;
export const ADD_MY_ORG_ENDPOINT_DIALOG_USERNAME =
  'add-my-org-endpoint-dialog-username';
export const ADD_MY_ORG_ENDPOINT_DIALOG_PASSWORD =
  'add-my-org-endpoint-dialog-password';

export const SHARE_ORG_ENDPOINT_DIALOG_SUBMIT =
  'share-org-endpoint-dialog-submit';
export const SHARE_ORG_ENDPOINT_DIALOG_CANCEL =
  'share-org-endpoint-dialog-cancel';
export const SHARE_ORG_ENDPOINT_DIALOG_EMAILS =
  'share-org-endpoint-dialog-emails';
export const SHARE_ORG_ENDPOINT_DIALOG_EMAILS_ITEM = (
  id: string,
  idx?: number
) => `share-org-endpoint-dialog-emails-item-${getTestId(id, idx)}`;
export const SHARE_ORG_ENDPOINT_DIALOG_ROLES =
  'share-org-endpoint-dialog-roles';
export const SHARE_ORG_ENDPOINT_DIALOG_ROLES_ITEM = (
  id: string,
  idx?: number
) => `share-org-endpoint-dialog-roles-item-${getTestId(id, idx)}`;

export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_SUBMIT =
  'edit-shared-org-endpoint-dialog-submit';
export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_CANCEL =
  'edit-shared-org-endpoint-dialog-cancel';
export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_EMAIL =
  'edit-shared-org-endpoint-dialog-email';
export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_EMAIL_CHIP = (
  id: string,
  idx?: number
) => `edit-shared-org-endpoint-dialog-email-chip-${getTestId(id, idx)}`;
export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_ROLES =
  'edit-shared-org-endpoint-dialog-roles';
export const EDIT_SHARED_ORG_ENDPOINT_DIALOG_ROLES_ITEM = (
  id: string,
  idx?: number
) => `edit-shared-org-endpoint-dialog-roles-item-${getTestId(id, idx)}`;

export const RENAME_MY_SHARED_ENDPOINT_DIALOG_SUBMIT =
  'rename-my-shared-endpoint-dialog-submit';
export const RENAME_MY_SHARED_ENDPOINT_DIALOG_CANCEL =
  'rename-my-shared-endpoint-dialog-cancel';
export const RENAME_MY_SHARED_ENDPOINT_DIALOG_NAME =
  'rename-my-shared-endpoint-dialog-name';

export const SHARE_ENDPOINT_DIALOG_SUBMIT = 'share-endpoint-dialog-submit';
export const SHARE_ENDPOINT_DIALOG_CANCEL = 'share-endpoint-dialog-cancel';
export const SHARE_ENDPOINT_DIALOG_EMAILS = 'share-endpoint-dialog-emails';
export const SHARE_ENDPOINT_DIALOG_EMAILS_ADD =
  'share-endpoint-dialog-emails-add';
export const SHARE_ENDPOINT_DIALOG_EMAILS_CHIP_REMOVE = (
  tag: string,
  idx?: number
) => `share-endpoint-dialog-emails-chip-remove-${getTestId(tag, idx)}`;
export const SHARE_ENDPOINT_DIALOG_ROLES = 'share-endpoint-dialog-roles';
export const SHARE_ENDPOINT_DIALOG_ROLES_ITEM = (id: string, idx?: number) =>
  `share-endpoint-dialog-roles-item-${getTestId(id, idx)}`;

export const EDIT_SHARED_ENDPOINT_DIALOG_SUBMIT =
  'edit-shared-endpoint-dialog-submit';
export const EDIT_SHARED_ENDPOINT_DIALOG_CANCEL =
  'edit-shared-endpoint-dialog-cancel';
export const EDIT_SHARED_ENDPOINT_DIALOG_EMAIL =
  'edit-shared-endpoint-dialog-email';
export const EDIT_SHARED_ENDPOINT_DIALOG_EMAIL_CHIP = (
  id: string,
  idx?: number
) => `edit-shared-endpoint-dialog-email-chip-${getTestId(id, idx)}`;
export const EDIT_SHARED_ENDPOINT_DIALOG_ROLES =
  'edit-shared-endpoint-dialog-roles';
export const EDIT_SHARED_ENDPOINT_DIALOG_ROLES_ITEM = (
  id: string,
  idx?: number
) => `edit-shared-endpoint-dialog-roles-item-${getTestId(id, idx)}`;

export const ADD_SSO_ENDPOINT_DIALOG_CANCEL = 'add-sso-endpoint-dialog-cancel';
export const ADD_SSO_ENDPOINT_DIALOG_SUBMIT = 'add-sso-endpoint-dialog-submit';
export const ADD_SSO_ENDPOINT_DIALOG_NAME = 'add-sso-endpoint-dialog-name';
export const ADD_SSO_ENDPOINT_DIALOG_ENDPOINT =
  'add-sso-endpoint-dialog-endpoint';
export const ADD_SSO_ENDPOINT_DIALOG_INTERNAL_ENDPOINT =
  'add-sso-endpoint-dialog-internal-endpoint';
export const ADD_SSO_ENDPOINT_DIALOG_REGISTRATION =
  'add-sso-endpoint-dialog-registration';
export const ADD_SSO_ENDPOINT_DIALOG_REGISTRATION_ITEM = (
  id: string,
  idx?: number
) => `add-sso-endpoint-dialog-registration-item-${getTestId(id, idx)}`;
